import * as React from 'react';
import MemberContainer from 'containers/member/MemberContainer';

const Member = () => {
  return <MemberContainer />;
};

export default Member;
